import { Provider, Type } from '@angular/core';

import { BaseSpecOptions, getDefaultBaseOptions } from '../base/options';
import { merge } from '../internals/merge';
import { HostComponent } from '../Spec-host/host-component';
import { OptionalsRequired } from '../types';

/**
 * @publicApi
 */
export interface SpecDirectiveOptions<D, H> extends BaseSpecOptions {
  directive: Type<D>;
  shallow?: boolean;
  detectChanges?: boolean;
  host?: Type<H>;
  template?: string;
  directiveProviders?: Provider[];
  directiveMocks?: Type<any>[];
  declareDirective?: boolean;
}

const defaultSpecRoutingOptions: OptionalsRequired<SpecDirectiveOptions<any, any>> = {
  ...getDefaultBaseOptions(),
  host: HostComponent,
  template: '',
  shallow: false,
  detectChanges: true,
  directiveProviders: [],
  directiveMocks: [],
  declareDirective: true
};

/**
 * @internal
 */
export function getSpecDirectiveDefaultOptions<D, H>(
  overrides?: SpecDirectiveOptions<D, H>
): Required<SpecDirectiveOptions<D, H>> {
  return merge(defaultSpecRoutingOptions, overrides);
}
